<script>
import classModifierMixin from './mixins/class-modifier-mixin'

export default {
	name: 'BaseCard',
	props: {
		header: {
			type: Boolean,
			default: false
		},
		collapsible: {
			type: Boolean,
			default: false
		},
		autoMode: {
			type: Boolean,
			default: true
		},
		autoState: {
			type: String,
			default: 'EXPAND'
		},
		cardIcon: {
			type: Array,
			default: () => ([])
		},
		ignoreIconClick: {
			type: Boolean,
			default: true
		}
	},
	mixins: [classModifierMixin],
	data: () => ({
		expanded: true,
		overIcon: false
	}),
	mounted: function () {
		if (this.collapsible) this.expanded = this.autoState === 'EXPAND'
	},
	watch: {
		autoMode: function (newVal) {
			if (this.collapsible && newVal) this.expanded = this.autoState === 'EXPAND'
		}
	},
	methods: {
		toggle: function () {
			if (this.overIcon) return
			if (this.collapsible && (!this.overIcon || this.ignoreIconClick)) {
				this.expanded = !this.expanded
				this.$emit('card-collapsed', { cardCollapsed: !this.expanded })
			}
		},
        toggleIcon: function () {
			this.overIcon = true
			if (!this.ignoreIconClick) {
				this.$emit('icon-clicked', { iconClicked: this.overIcon })
			}
        }
	}
}
</script>

<template>
	<div class="base-card" :class="modifierClasses" v-on="$listeners">
		<div class="base-card__header" v-if="header"
             :class="{'base-card__header--clickable': collapsible}"
             @click="toggle">
			<slot name="header"></slot>
			<div class="base-card__icon" v-if="cardIcon.length > 0">
				<font-awesome-icon :icon="cardIcon"
                                   @click="toggleIcon"
                                   @mouseleave="overIcon = false"
                                   data-testid="base-card-icon" />
			</div>
		</div>
		<div class="base-card__content" v-show="expanded">
			<slot name="content" :toggle="toggle"></slot>
		</div>
	</div>
</template>

<style lang="scss">
	.base-card {
		width: 100%;
		margin: 0.5rem auto;
		max-width: 800px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		background-color: var(--surface-colour);
		border-radius: var(--border-radius);
        color: var(--on-surface);
		padding: 1.5rem;
		@media (max-width: 600px) {
			margin: 0.25rem 0;
		}
        &--border {
            border: 1px solid var(--border-colour);
        }
		&__header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			cursor: default;
			position: relative;
			&--clickable {
				cursor: pointer;
			}
		}
		&__icon {
			right: 1rem;
			top: 1rem;
			margin-right: 1rem;
			color: var(--background-variant-medium);
			font-size: 1.1rem;
		}
		&__content {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			&--column {
				flex-direction: row;
				@media (max-width: 750px) {
					flex-direction: column;
				}
			}
		}
		&--box-shadow {
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
		}
		&--bg-primary {
			background-color: var(--primary-variant-light);
			color: var(--on-primary);
		}
		&--bg-gradient {
			background-image: linear-gradient(var(--accent-colour), var(--primary-colour), var(--primary-colour));
			color: var(--on-primary);
		}
		&--padding-1rem {
			padding: 1rem;
		}
		&--padding-2rem {
			padding: 2rem;
		}
		&--max-width-500px {
			max-width: 500px;
		}
		&--responsive {
			@media (max-width: 750px) {
				padding: 1rem;
			}
		}
		&--tiled {
			@media (max-width: 600px) {
				margin: 0;
				border-radius: 0px;
			}
		}
	}
	.slide-up-enter-active {
		transition: all .2s ease;
	}
	.slide-up-leave-active {
		transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-up-enter, .slide-fade-leave-to {
		transform: translateY(100vh);
		opacity: 0;
	}
</style>
